import MemberLayout from '@/components/Layout/MemberLayout';
import CustomAccountTable from '@/components/v2/CustomAccountTable';

const AccountCredit = () => {
  return (
    <MemberLayout>
      <CustomAccountTable tableHeadings={ACCOUNT_TABLE_HEAD} name="account_credit" />
    </MemberLayout>
  );
};

export default AccountCredit;

const ACCOUNT_TABLE_HEAD = [
  {
    id: 1,
    heading: '交易日期'
  },
  {
    id: 2,
    heading: '交易狀態'
  },
  {
    id: 3,
    heading: '訂單編號'
  },
  {
    id: 4,
    heading: '總金額'
  },
  {
    id: 5,
    heading: '點數'
  }
];
